/**
 * @desc cancelStockOccupyForBill
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  params: API.tms.stockOccupyFacadeImpl.cancelStockOccupyForBill.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/stockOccupy/cancelStockOccupyForBill`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
